export default __webpack_public_path__ + "static/media/gridview.ee299b6f.svg";